import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AntdProvider } from '@app/providers/AntdProvider';
import { QueryProvider } from '@app/providers/QueryProvider';
import { ThemeProvider } from '@app/providers/ThemeProvider';
import { AuthProvider } from '@app/providers/AuthProvider';
import { ErrorBoundary } from '@app/ErrorBoundary';
import { routes } from '@app/routes';

const router = createBrowserRouter(routes);

export function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <AntdProvider>
            <AuthProvider>
              <RouterProvider router={router} />
              <Toaster position="top-right" richColors closeButton expand={false} />
            </AuthProvider>
          </AntdProvider>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
